export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/valueOf.js
// module id = 809
// module chunks = 67